import React from 'react';
import { LocationAutocomplete } from '@/components/ui';
import { useNotificationStore } from '@/stores/notificationStore';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function LocationAutocompleteSection() {
  const notifySuccess = useNotificationStore(s => s.success);

  return (
    <SectionWrapper title="Location Autocomplete">
        <div>
          <h3 className="text-lg font-semibold mb-4">Google Places Integration</h3>
          <div className="space-y-6">
            <div>
              <p className="text-sm text-muted-foreground mb-3">Address and city search</p>
              <LocationAutocomplete
                placeholder="Search for any location..."
                types="address"
                onLocationSelect={(location) => {
                  notifySuccess(`Selected: ${location.formatted_address}`);
                }}
              />
            </div>
            <div>
              <p className="text-sm text-muted-foreground mb-3">Cities only</p>
              <LocationAutocomplete
                placeholder="Search for cities..."
                types="cities"
                onLocationSelect={(location) => {
                  notifySuccess(`Selected: ${location.city}, ${location.region}, ${location.country_iso2}`);
                }}
              />
            </div>
          </div>
          <CodeBlock>
{`import { LocationAutocomplete } from '@/components/ui';

<LocationAutocomplete
  placeholder="Search for locations..."
  types="address" // or "cities"
  onLocationSelect={(location) => {
    console.log('Selected location:', location);
    // location contains: place_id, lat, lon, city, region, country_iso2, etc.
  }}
/>`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
